import { MediaType } from '../MediaType';
import { throwErrorWithResponse } from '../throwErrorWithResponse';
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';

export const experimentalResetCollabService: ExperimentalMutations['experimentalResetCollabService'] =
	(_, { contentId, behind }, { network: { cfetch, getTraceIdFromResponse } }) =>
		cfetch(`/wiki/rest/collab/1.0/content/${contentId}/reset?behind=${behind || 'COLLAB'}`, {
			method: 'PUT',
			headers: {
				'Content-Type': MediaType.JSON,
			},
		}).then(
			(response) => ({
				traceId: getTraceIdFromResponse(response) ?? '',
			}),
			(error) => throwErrorWithResponse(error, error?.response),
		);
